import {LinkButton} from '@components/common/base/buttons'
import {canAdd} from '@components/dashboard/dashboard-utils'
import React from 'react'

export const LinkAdd = ({
  handler,
  title
}: {
  handler: (e: React.MouseEvent) => void
  title: string
}) => {
  if (!canAdd()) {
    return null
  }
  return (
    <LinkButton onClick={handler} size="small" icon="IconCirclePlus">
      {title}
    </LinkButton>
  )
}
